/* DECOMURA: wspólna kolejka obrazów i stabilny wybór podczas wizyty. */
(function () {
  'use strict';
  if (window.DcmVisuals) return;
  var seed;
  try { seed = sessionStorage.getItem('dcm-visit-seed'); } catch (_) {}
  if (!seed) {
    seed = String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    try { sessionStorage.setItem('dcm-visit-seed', seed); } catch (_) {}
  }
  function hash(value) {
    var h = 2166136261;
    for (var i = 0; i < value.length; i++) { h ^= value.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rank(items, counts, key) {
    return items.slice().sort(function (a, b) {
      var ah = key(a), bh = key(b);
      var ac = counts[ah], bc = counts[bh];
      ac = typeof ac === 'object' ? ac.total : ac;
      bc = typeof bc === 'object' ? bc.total : bc;
      return (Number(bc) || 0) - (Number(ac) || 0) || hash(seed + ah) - hash(seed + bh) || ah.localeCompare(bh);
    });
  }
  var queue = [], running = 0, jobs = new WeakMap();
  function ready(image, urgent) {
    if (!image) return Promise.resolve(false);
    var current = jobs.get(image);
    if (current) {
      if (urgent && queue.includes(current)) { queue.splice(queue.indexOf(current), 1); queue.unshift(current); }
      return current.promise;
    }
    var job = { image: image };
    job.promise = new Promise(function (resolve) { job.resolve = resolve; });
    jobs.set(image, job);
    if (urgent) queue.unshift(job); else queue.push(job);
    pump();
    return job.promise;
  }
  function pump() {
    while (running < 4 && queue.length) {
      var job = queue.shift();
      if (!job.image.isConnected) { jobs.delete(job.image); job.resolve(false); continue; }
      running++;
      load(job);
    }
  }
  async function load(job) {
    var image = job.image, timer;
    try {
      var loaded = new Promise(function (resolve, reject) {
        function clean() { image.removeEventListener('load', done); image.removeEventListener('error', fail); clearTimeout(timer); }
        function done() { clean(); resolve(); }
        function fail() { clean(); reject(new Error('Obraz niedostępny')); }
        image.addEventListener('load', done, { once: true });
        image.addEventListener('error', fail, { once: true });
        timer = setTimeout(fail, 15000);
        image.fetchPriority = 'low';
        image.loading = 'eager';
        // sizes ustawiamy przed srcset: także po zmianie gęstości i doczytaniu.
        if (window.dcmApplyImageSizes) window.dcmApplyImageSizes(image.closest('[data-dcm-responsive]') || image);
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.complete && image.naturalWidth) done();
      });
      await loaded;
      if (image.decode) await image.decode();
      job.resolve(Boolean(image.naturalWidth));
    } catch (_) {
      jobs.delete(image);
      job.resolve(false);
    } finally { clearTimeout(timer); running--; pump(); }
  }
  var prepared = new WeakSet(), przygotowane = new WeakSet();
  // Klatki poza aranzacja pobieramy dopiero, gdy ktos siega po kafel (najechanie, fokus, strzalka).
  // Pobieranie ich z gory przy wjechaniu w widok zajmowalo lacze i opozniało aranzacje kolejnych kafli.
  function przygotuj(media) {
    if (!media || przygotowane.has(media)) return;
    przygotowane.add(media);
    var klatki = media.querySelectorAll('[data-dcm-frame]:not([data-dcm-frame="room"])');
    klatki.forEach(function (image, i) { ready(image, i === 0); });
  }
  function initCards() {
    document.querySelectorAll('[data-dcm-preview]').forEach(function (media) {
      if (prepared.has(media)) return;
      prepared.add(media);
      var bank = media.querySelector('template[data-dcm-scenes]');
      var candidates = bank ? Array.from(bank.content.querySelectorAll('img')) : [];
      candidates.sort(function (a,b) { return hash(seed + media.dataset.productId + a.dataset.mediaId) - hash(seed + media.dataset.productId + b.dataset.mediaId); });
      var selected = candidates.slice(0,2);
      var link = media.querySelector('a'), list = media.dataset.dcmFrames.split(',').filter(Boolean);
      selected.forEach(function (image, i) { image.dataset.dcmFrame = 'scene' + i; list.push('scene' + i); link.appendChild(image); });
      media.dataset.dcmFrames = list.join(',');
      var card = media.closest('[data-dcm-dawn-card]');
      var segments = card.querySelector('[data-dcm-segments]');
      if (segments) { segments.replaceChildren(); list.forEach(function () { segments.appendChild(document.createElement('span')); }); }
      card.querySelectorAll('.dcm-card-steps').forEach(function (controls) { controls.hidden = !list.length; });
      if (bank) bank.remove();
      if (window.dcmApplyImageSizes) window.dcmApplyImageSizes(media);
    });
  }
  var tiles = new WeakMap(), tileObserved = new Set();
  function countsFor(handles) {
    if (window.DcmCounts) return window.DcmCounts.get(handles);
    return new Promise(function (resolve,reject) {
      var timer=setTimeout(function () { document.removeEventListener('dcm:counts:ready', loaded); reject(new Error('Brak liczników')); },15000);
      function loaded() { clearTimeout(timer); window.DcmCounts.get(handles).then(resolve,reject); }
      document.addEventListener('dcm:counts:ready',loaded,{once:true});
    });
  }
  function warmTile(state) { state.selected.forEach(function (img) { ready(img); }); }
  function busyTile(state) { return state.hovering || state.tile.contains(document.activeElement) || state.manual; }
  async function applyRanking(state) {
    if (!state.ranking || busyTile(state)) return;
    var selection=state.ranking;
    if (!await ready(selection[0],true) || !state.tile.isConnected || busyTile(state)) return;
    state.selected=selection; state.ranking=null; state.chosen=0; state.request++;
    activateTile(state,0); warmTile(state);
  }
  function activateTile(state,index) {
    var image=state.selected[index];
    if (!image) return;
    state.images.forEach(function (img) { img.classList.toggle('is-active',img===image); img.setAttribute('aria-hidden',String(img!==image)); });
    state.index=index;
    state.track.dataset.dcmIndex=String(index);
    state.dots.forEach(function (dot,i) { dot.classList.toggle('is-active',i===index); dot.setAttribute('aria-pressed',String(i===index)); });
  }
  async function showTile(state,index,manual) {
    index=Math.max(0,Math.min(state.selected.length-1,index));
    if (manual) { state.manual=true; state.chosen=index; }
    if (state.requested===index) return;
    state.requested=index;
    var token=++state.request;
    if (await ready(state.selected[index],true) && token===state.request && state.tile.isConnected) activateTile(state,index);
  }
  async function enterTile(state) {
    if (state.entered) return;
    state.entered=true;
    warmTile(state);
    try {
      var counts=await countsFor(state.images.map(function (image) { return image.dataset.handle; }));
      state.ranking=rank(state.images,counts,function (img) { return img.dataset.handle; }).slice(0,5);
      applyRanking(state);
    } catch (_) { /* Brak ERP zostawia dokładnie kolejność serwera. */ }
  }
  var tileVisibility='IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      tileVisibility.unobserve(entry.target); tileObserved.delete(entry.target);
      enterTile(tiles.get(entry.target));
    });
  }) : null;
  function initTiles() {
    tileObserved.forEach(function (tile) { if (!tile.isConnected) { tileVisibility.unobserve(tile); tileObserved.delete(tile); } });
    document.querySelectorAll('[data-dcm-coltile]').forEach(function (tile) {
      if (tiles.has(tile)) return;
      var track=tile.querySelector('[data-dcm-track]'), images=Array.from(track.querySelectorAll('[data-dcm-candidate]'));
      if (!images.length) return;
      var state={tile:tile,track:track,images:images,selected:images.slice(0,5),dots:Array.from(tile.querySelectorAll('[data-dcm-tile-index]')),steps:Array.from(tile.querySelectorAll('[data-dcm-tile-step]')),index:0,chosen:0,request:0,requested:0,hovering:false,manual:false};
      tiles.set(tile,state); tile.classList.add('dcm-coltile--ready');
      var fine=matchMedia('(any-hover:hover) and (any-pointer:fine)'), reduced=matchMedia('(prefers-reduced-motion:reduce)');
      var gesture=null,suppress=false;
      track.addEventListener('pointermove',function (event) {
        if (gesture && (Math.abs(event.clientX-gesture.x)>8 || Math.abs(event.clientY-gesture.y)>8)) suppress=true;
        if (event.pointerType!=='mouse' || event.buttons || !fine.matches || reduced.matches || tile.contains(document.activeElement)) return;
        state.hovering=true;
        var rect=track.getBoundingClientRect();
        showTile(state,Math.floor((event.clientX-rect.left)/rect.width*state.selected.length),false);
      },{passive:true});
      tile.addEventListener('pointerenter',function (event) { if(event.pointerType==='mouse') state.hovering=true; });
      tile.addEventListener('pointerleave',function () { state.hovering=false; showTile(state,state.chosen,false); applyRanking(state); });
      track.addEventListener('pointerdown',function (event) { suppress=false; gesture={x:event.clientX,y:event.clientY}; },{passive:true});
      track.addEventListener('pointerup',function (event) {
        if (!gesture) return;
        var dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
        if (Math.abs(dx)>30 && Math.abs(dx)>Math.abs(dy)) { suppress=true; showTile(state,(state.index+(dx<0?1:-1)+state.selected.length)%state.selected.length,true); }
        gesture=null;
      },{passive:true});
      track.addEventListener('pointercancel',function () { gesture=null; suppress=true; });
      tile.querySelector('a').addEventListener('click',function (event) { if(suppress && event.detail!==0) {event.preventDefault();event.stopPropagation();} suppress=false; },true);
      state.dots.forEach(function (dot,i) { dot.addEventListener('click',function () { showTile(state,i,true); }); });
      state.steps.forEach(function (button) {
        button.hidden = state.selected.length < 2;
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var step = Number(button.dataset.dcmTileStep) || 0;
          if (!step) return;
          showTile(state, (state.index + step + state.selected.length) % state.selected.length, true);
        });
      });
      tile.addEventListener('focusout',function () { setTimeout(function () { applyRanking(state); },0); });
      if (tileVisibility) { tileObserved.add(tile);tileVisibility.observe(tile); }
      else {
        // Starsza przeglądarka nadal ogranicza odczyt liczników do widocznych kafli.
        function check() { var r=tile.getBoundingClientRect();if(r.top<innerHeight && r.bottom>0){removeEventListener('scroll',check);enterTile(state);} }
        addEventListener('scroll',check,{passive:true});check();
      }
    });
  }
  window.DcmVisuals = { ready: ready, przygotuj: przygotuj, rank: rank, hash: function (value) { return hash(seed + value); }, initCards: initCards, initTiles:initTiles, counts:countsFor };
})();
